<template>
  <div
    class="h-100 d-flex align-items-center flex-column overflow-auto"
    :style="{'background-color': bgColor}"
  >
    <div
      class="container px-0 bg-white shadow-custom flex-grow-1 flex-lg-grow-0"
      style="max-width:640px;"
    >
      <SurveyHeader
        :image-src="imageSrc"
        :is-end="true"
      />
      <div
        v-if="title || content || btnText"
        class="p-4"
      >
        <h1
          v-if="title"
          class="h4 text-break text-break-word"
        >
          {{ title }}
        </h1>
        <p
          v-if="content"
          class="text-gray600 text-break text-break-word"
          v-html="content"
        />
        <b-button
          v-if="type==='result' && btnText && btnUrl"
          variant="success"
          size="lg"
          block
          class="d-block bg-customize border-customize"
          :style="{'--theme-color': themeColor['--theme-color'], 'color': themeFontColor}"
          @click="goUrl"
        >
          {{ btnText }}
        </b-button>
      </div>
    </div>

    <!-- 填完本次問卷 -->
    <MaskLayer v-if="showFinishPopup">
      <Popup
        :text-of-o-k="textOfOK"
        :hide-cancel="true"
        @confirm="closeFinishPopup"
        @cancel="closeFinishPopup"
        @close="closeFinishPopup"
      >
        <h5 class="alert-heading">
          {{ $t('errorMessageFinal') }}
        </h5>
      </Popup>
    </MaskLayer>
  </div>
</template>

<script>
import SurveyHeader from '@/components/SurveyHeader.vue';
import { mapActions, mapState, mapMutations } from 'vuex';
// import { teClient } from '@/config';
import MaskLayer from '@/components/MaskLayer.vue';
import Popup from '@/components/Popup.vue';

export default {
  components: {
    SurveyHeader,
    MaskLayer,
    Popup
  },
  data() {
    return {
      textOfOK: this.$t('confirm')
    };
  },
  methods: {
    ...mapActions('form', ['postMemberTag']),
    ...mapMutations('form', ['setFormData']),
    goUrl() {
      const endPageHaveTag = this.surveyTemplateData.formInfo.find((d) => d.formparam === 'EndPage_ButtonTags');

      let companyTagNoLength = 0;

      if (endPageHaveTag) {
        const list = endPageHaveTag.formvalue.split('|');
        const companyTagNo = [];

        list.forEach((element) => {
          const num = element.split(',')[0];

          if (num) {
            companyTagNo.push(parseInt(num, 10));
          }
        });

        companyTagNoLength = companyTagNo.length;

        if (companyTagNoLength) {
          this.postMemberTag(companyTagNo).then(() => {
            this.relaGoOut();
          });
        } else {
          this.relaGoOut();
        }
      } else {
        this.relaGoOut();
      }
    },
    relaGoOut() {
      if (this.btnUrl !== 'preview') {
        window.location.href = this.btnUrl;
      }
    },
    closeFinishPopup() {
      this.setFormData({ id: 'showFinishPopup', value: false });
    }
  },
  props: {
    title: String,
    content: String,
    btnText: String,
    imageSrc: String,
    type: String,
    btnUrl: String
  },
  computed: {
    ...mapState('form', ['surveyTemplateData', 'labelingInformation', 'showFinishPopup']),
    ...mapState('formSetting', [
      'bgColor',
      'bgFontColor',
      'themeColor',
      'themeFontColor'
    ])
  }
};
</script>
